export enum StatusChartMode {
    Frequency,
    Chronological
}